import { coachingSessionLeaveGuard } from '../scoreboard/components/video-analysis/coaching-session-leave.guard';
import { Routes } from '@angular/router';
import { adminGuard, authGuard, statsImporterGuard } from '../../core/guards';

export const sportsRoutes: Routes = [
  {
    path: 'sports',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/list/sport-list.component').then((m) => m.SportListComponent),
      },
      {
        path: 'create',
        redirectTo: 'new',
        pathMatch: 'full',
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/create/sport-create.component').then((m) => m.SportCreateComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':sportId/seasons/:year/tournaments/new',
        loadComponent: () =>
          import('../tournaments/components/create/tournament-create.component').then(
            (m) => m.TournamentCreateComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/seasons/:year/tournaments/:id/edit',
        loadComponent: () =>
          import('../tournaments/components/edit/tournament-edit.component').then(
            (m) => m.TournamentEditComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/seasons/:year/tournaments/:id',
        loadComponent: () =>
          import('../tournaments/components/detail/tournament-detail.component').then(
            (m) => m.TournamentDetailComponent
          ),
      },
      {
        path: ':sportId/seasons/:year/tournaments/:id/parse-eesl',
        loadComponent: () =>
          import('../tournaments/components/parse-eesl/tournament-parse-eesl.component').then(
            (m) => m.TournamentParseEeslComponent
          ),
        canActivate: [statsImporterGuard],
      },
      {
        path: ':sportId/seasons/:year/tournaments/:id/parse-matches',
        loadComponent: () =>
          import(
            '../tournaments/components/parse-matches/tournament-parse-matches.component'
          ).then((m) => m.TournamentParseMatchesComponent),
        canActivate: [statsImporterGuard],
      },
      {
        path: ':sportId/seasons/:year/tournaments/:id/teams/:teamId',
        loadComponent: () =>
          import('../teams/components/detail/team-detail.component').then(
            (m) => m.TeamDetailComponent
          ),
      },
      {
        path: ':sportId/seasons/:year/teams/:teamId',
        loadComponent: () =>
          import('../teams/components/detail/team-detail.component').then(
            (m) => m.TeamDetailComponent
          ),
      },
      {
        path: ':sportId/teams/new',
        loadComponent: () =>
          import('../teams/components/create/team-create.component').then(
            (m) => m.TeamCreateComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/teams/:teamId/edit',
        loadComponent: () =>
          import('../teams/components/edit/team-edit.component').then(
            (m) => m.TeamEditComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/teams/:teamId/trainings/:trainingId',
        canDeactivate: [coachingSessionLeaveGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('../trainings/components/detail/training-detail.component').then(
            (m) => m.TrainingDetailComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/teams/:teamId',
        loadComponent: () =>
          import('../teams/components/detail/team-detail.component').then(
            (m) => m.TeamDetailComponent
          ),
      },
      {
        path: ':sportId/matches/new',
        loadComponent: () =>
          import('../matches/components/create/match-create.component').then(
            (m) => m.MatchCreateComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/matches/:id/edit',
        loadComponent: () =>
          import('../matches/components/edit/match-edit.component').then(
            (m) => m.MatchEditComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: ':sportId/matches/:id',
        loadComponent: () =>
          import('../matches/components/detail/match-detail.component').then(
            (m) => m.MatchDetailComponent
          ),
      },
      {
        path: ':sportId/players/:playerId',
        loadComponent: () =>
          import('../players/components/detail/player-detail.component').then(
            (m) => m.PlayerDetailComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./components/detail/sport-detail.component').then((m) => m.SportDetailComponent),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/edit/sport-edit.component').then((m) => m.SportEditComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':sportId/parse-eesl',
        loadComponent: () =>
          import('./components/parse-eesl/sport-parse-eesl.component').then(
            (m) => m.SportParseEeslComponent
          ),
        canActivate: [statsImporterGuard],
      },
    ],
  },
];
